import { requestApi } from './Api';

export const getEvent = async (navigate, params, signal) =>
  requestApi({ url: '/api/calendar_event/get_one', navigate, params, signal });
